import { render, staticRenderFns } from "./ResourcesResearch.vue?vue&type=template&id=d8e08d06&"
import script from "./ResourcesResearch.vue?vue&type=script&lang=js&"
export * from "./ResourcesResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports